/**
 * define all the modals here
 */
export const modalIds = {
  LOADING_MODAL: 'LOADING_MODAL',
  LANDING_MODAL: 'LANDING_MODAL',
  FILTERS_MODAL: 'FILTERS_MODAL',
}
